import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftAddon,
} from '@wegroup/design-system';
import React from 'react';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import { Change } from '../../../../../../../types/Form';
import { prefilledInputComponentStyling } from '../../../../constants/InputComponentStyling';
import useFlowsCurrency from '../../../../hooks/useFlowsCurrency';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { Inputs } from '../../../../types/Enums';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { getFlowsDataTestId } from '../../../../utils/testUtils';

interface Props {
  question: FlowsQuestion;
}

const CurrencyInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur, onChange },
    error,
    prefilled,
  } = useFlowInputComponent({
    question,
  });

  const { symbol } = useFlowsCurrency();

  const handleChange = (change: Change) => {
    const { name, value } = change;
    onChange({ name, value: value === '' ? undefined : value });
  };

  const handleOnBlur = () => {
    onBlur({
      name: question.id,
      value,
    });
  };

  return (
    <FormControl isInvalid={!!error}>
      <InputGroup>
        <InputLeftAddon
          h="4.5rem"
          bg="white"
          color="text.gray"
          borderColor="#e4e4e4"
          boxShadow="base"
          opacity={question.rules.is_disabled ? '0.4' : '1'}
          {...(prefilled && { sx: prefilledInputComponentStyling })}
        >
          {question.rules.symbol || symbol}
        </InputLeftAddon>
        <Input
          variant="flows"
          name={question.id}
          as={NumberFormat}
          thousandSeparator="."
          decimalSeparator=","
          value={value}
          onValueChange={(values: NumberFormatValues) => {
            const { formattedValue } = values;
            handleChange({
              name: question.id,
              value: Number(
                formattedValue.replaceAll('.', '').replace(',', '.'),
              ),
            });
          }}
          onBlur={handleOnBlur}
          data-test-id={getFlowsDataTestId(Inputs.CURRENCY, question.id)}
          isDisabled={question.rules.is_disabled}
          {...(prefilled && { sx: prefilledInputComponentStyling })}
        />
      </InputGroup>
      {error?.message && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export default CurrencyInputComponent;
